import type { App, Directive, DirectiveBinding } from 'vue'

import { applyPerm } from '../composables/usePermissions'

const perm: Directive<HTMLElement, string | string[]> = {
  mounted(el, binding: DirectiveBinding<string | string[]>) {
    applyPerm(el, binding.value)
  },
  updated(el, binding: DirectiveBinding<string | string[]>) {
    if (binding.value === binding.oldValue) return
    applyPerm(el, binding.value)
  },
}

export function installPerm(app: App): void {
  app.directive('perm', perm)
}

export default perm